export default class UrlUtils {

  // Utility method to check if the category action should be true
  static checkUrl(routerUrl: string): boolean {
    const isArabicBrowser = UrlUtils.isArabicBrowser();
    return routerUrl.includes('clang=ar') && routerUrl.includes('ulang=ar') || isArabicBrowser;
  }

  // Utility method to detect if the browser language is Arabic
  static isArabicBrowser(): boolean {
    const browserLanguage = navigator.language || navigator.languages[0];
    return browserLanguage.startsWith('ar');
  }
}